export default "__VITE_ASSET__Dgai58Cd__"